import { Typography } from "@mui/material";
import { RobotAgent } from "../../panels/worldpanelparts/robot/RobotAgent";
import { FlexContainer } from "../../components/FlexContainer";
import { RobotButton } from "./RobotButton";
import { Fullscreen, TouchApp, ViewInAr } from "@mui/icons-material";
import { RobotViewMode } from "../../panels/worldpanelparts/robot/RobotViewManager";
import { useEffect, useState } from "react";
import { AgentEvents } from "../../panels/worldpanelparts/agents/BaseAgent";

export function MapToolbar({ agent }: { agent: RobotAgent }) {
  const [mode, setMode] = useState(agent.viewManager.getMode());
  useEffect(() => {
    const viewModeListener = (m: RobotViewMode) => setMode(m);
    agent.on(AgentEvents.ViewManagerChange, viewModeListener);
    return () => {
      agent.off(AgentEvents.ViewManagerChange, viewModeListener);
    }
  }, [agent]);
  const vm = agent.viewManager;
  const color = 'success';
  return (
    <FlexContainer>
      <Typography variant="h6">
        ...
      </Typography>
      <div>
        <RobotButton
          color={color}
          select id='viewSelect'
          actions={[
            {
              name: 'Manual',
              Icon: <TouchApp color={color} fontSize="large" />,
              onClick: () => vm.setMode(RobotViewMode.Manual),
              active: mode === RobotViewMode.Manual,
            },
            {
              name: 'Follow',
              Icon: <ViewInAr color={color} fontSize="large" />,
              onClick: () => vm.setMode(RobotViewMode.Follow),
              active: mode === RobotViewMode.Follow,
            },
            {
              name: 'Top-down',
              Icon: <Fullscreen color={color} fontSize="large" />,
              onClick: () => vm.setMode(RobotViewMode.TopDown),
              active: mode === RobotViewMode.TopDown
            }
          ]}
        />
      </div>
    </FlexContainer>
  )
}